module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.61da8e92.png";